import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = []
  static values = {
    resource: String
  }

  connect() {
  }

  update(event) {
    console.log('🔄 Selectors update triggered');
    console.log('Field changed:', event.currentTarget.name);
    console.log('New value:', event.currentTarget.value);

    this.reset_fields(event);

    const form = event.target.closest("form");
    let baseUrl, params;

    if (form) {
      // Traditional form-based approach
      const formActionUrl = new URL(form.action);
      baseUrl = `${formActionUrl.origin}/selectors/update`;
      params = new URLSearchParams(new FormData(form));
    } else {
      // Standalone select approach (for distribution matrix filters)
      baseUrl = `${window.location.origin}/selectors/update`;
      params = new URLSearchParams();

      // Add the current select's data
      const fieldName = event.currentTarget.name;
      const fieldValue = event.currentTarget.value;

      // For multi-select, get all selected values
      if (event.currentTarget.multiple) {
        const selectedValues = Array.from(event.currentTarget.selectedOptions).map(opt => opt.value);
        selectedValues.forEach(value => {
          if (value) params.append(fieldName, value);
        });
      } else if (fieldValue) {
        params.append(fieldName, fieldValue);
      }
    }

    params.append('field_changed', event.currentTarget.name);

    const fetchUrl = `${baseUrl}?${params.toString()}`;
    console.log('📡 Fetching:', fetchUrl);

    fetch(fetchUrl, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html'
      }
    }).then(response => {
      console.log('📥 Response status:', response.status);
      if (!response.ok) {
        throw new Error(`Network response was not ok ${response.statusText} for the selector change fetch operation.`);
      }
      return response.text();
    }).then(html => {
      console.log('✅ Turbo stream received');
      Turbo.renderStreamMessage(html);
      console.log('✅ Turbo stream rendered');
    }).catch(error => {
      console.error('❌ Error in selector change fetch operation:', error);
    });
  }

  reset_fields(event) {
    if (event.currentTarget.name == "stock[stockable_state]") {
      document.querySelector('select[name="stock[stockable_id]"]').value = "";
    }
    if (event.currentTarget.name == "stock[stockable_type]") {
      document.querySelector('select[name="stock[stockable_state]"]').value = "";
      document.querySelector('select[name="stock[stockable_retailer]"]').value = "";
      document.querySelector('select[name="stock[stockable_id]"]').value = "";
    }
    if (event.currentTarget.name == "stock[client_id]") {
      document.querySelector('select[name="stock[product_id]"]').value = "";
      document.querySelector('select[name="stock[stockable_state]"]').value = "";
      document.querySelector('select[name="stock[stockable_retailer]"]').value = "";
      document.querySelector('select[name="stock[stockable_id]"]').value = "";
    }

    // Product hierarchy cascading for search (q)
    if (event.currentTarget.name == "q[client_id_eq]") {
      const brandSelect = document.querySelector('select[name="q[brand_id_eq]"]');
      const ph1Select = document.querySelector('select[name="q[ph1_id_eq]"]');
      const ph2Select = document.querySelector('select[name="q[ph2_id_eq]"]');
      const ph3Select = document.querySelector('select[name="q[ph3_id_eq]"]');
      if (brandSelect) brandSelect.value = "";
      if (ph1Select) ph1Select.value = "";
      if (ph2Select) ph2Select.value = "";
      if (ph3Select) ph3Select.value = "";
    }
    if (event.currentTarget.name == "q[ph1_id_eq]") {
      const ph2Select = document.querySelector('select[name="q[ph2_id_eq]"]');
      const ph3Select = document.querySelector('select[name="q[ph3_id_eq]"]');
      if (ph2Select) ph2Select.value = "";
      if (ph3Select) ph3Select.value = "";
    }
    if (event.currentTarget.name == "q[ph2_id_eq]") {
      const ph3Select = document.querySelector('select[name="q[ph3_id_eq]"]');
      if (ph3Select) ph3Select.value = "";
    }

    // Product hierarchy cascading for product forms
    if (event.currentTarget.name == "product[client_id]") {
      console.log('🧹 Resetting product form fields for client change');
      const brandSelect = document.querySelector('select[name="product[brand_id]"]');
      const ph1Select = document.querySelector('select[name="product[ph1_id]"]');
      const ph2Select = document.querySelector('select[name="product[ph2_id]"]');
      const ph3Select = document.querySelector('select[name="product[ph3_id]"]');
      if (brandSelect) {
        console.log('  - Resetting brand field');
        brandSelect.value = "";
      }
      if (ph1Select) ph1Select.value = "";
      if (ph2Select) ph2Select.value = "";
      if (ph3Select) ph3Select.value = "";
    }
    if (event.currentTarget.name == "product[ph1_id]") {
      const ph2Select = document.querySelector('select[name="product[ph2_id]"]');
      const ph3Select = document.querySelector('select[name="product[ph3_id]"]');
      if (ph2Select) ph2Select.value = "";
      if (ph3Select) ph3Select.value = "";
    }
    if (event.currentTarget.name == "product[ph2_id]") {
      const ph3Select = document.querySelector('select[name="product[ph3_id]"]');
      if (ph3Select) ph3Select.value = "";
    }

    // Product hierarchy cascading for distribution matrix
    if (event.currentTarget.name == "distribution[ph1_ids][]") {
      console.log('🧹 Resetting distribution PH2 and PH3 for PH1 change');
      const ph2Select = document.querySelector('select[name="distribution[ph2_ids][]"]');
      const ph3Select = document.querySelector('select[name="distribution[ph3_ids][]"]');
      if (ph2Select && ph2Select._slim) {
        ph2Select._slim.set([]);
      }
      if (ph3Select && ph3Select._slim) {
        ph3Select._slim.set([]);
      }
    }
    if (event.currentTarget.name == "distribution[ph2_ids][]") {
      console.log('🧹 Resetting distribution PH3 for PH2 change');
      const ph3Select = document.querySelector('select[name="distribution[ph3_ids][]"]');
      if (ph3Select && ph3Select._slim) {
        ph3Select._slim.set([]);
      }
    }
  }

}